module.exports = __webpack_public_path__ + "fonts/sourcesanspro-light-webfont.346207c0.woff";